import { CoinPouch } from './CoinPouch';
import { CreaturedexCard } from './CreaturedexCard';

export function RewardsHero() {
  return (
    <section className="grid grid-cols-1 md:grid-cols-[1.1fr_1fr] gap-8 items-start">
      <CoinPouch />
      <CreaturedexCard />
    </section>
  );
}
